var _circle, _circle2, _rect, _rect2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgContentMarketingImageBg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 543,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1269.5,
    cy: 524.5,
    r: 15,
    transform: "rotate(-180 1269.5 524.5)",
    stroke: "#387",
    strokeOpacity: 0.07,
    strokeWidth: 7
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1326.5,
    cy: 70.5,
    r: 15,
    transform: "rotate(-180 1326.5 70.5)",
    stroke: "#387",
    strokeOpacity: 0.07,
    strokeWidth: 7
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 739,
    y: 33,
    width: 5,
    height: 31,
    rx: 2.5,
    transform: "rotate(-180 739 33)",
    fill: "#F9DB6D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 721,
    y: 20,
    width: 5,
    height: 31,
    rx: 2.5,
    transform: "rotate(-90 721 20)",
    fill: "#F9DB6D"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQ0MCIgaGVpZ2h0PSI1NDMiIHZpZXdCb3g9IjAgMCAxNDQwIDU0MyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTI2OS41IiBjeT0iNTI0LjUiIHI9IjE1IiB0cmFuc2Zvcm09InJvdGF0ZSgtMTgwIDEyNjkuNSA1MjQuNSkiIHN0cm9rZT0iIzMzODg3NyIgc3Ryb2tlLW9wYWNpdHk9IjAuMDciIHN0cm9rZS13aWR0aD0iNyIvPgo8Y2lyY2xlIGN4PSIxMzI2LjUiIGN5PSI3MC41IiByPSIxNSIgdHJhbnNmb3JtPSJyb3RhdGUoLTE4MCAxMzI2LjUgNzAuNSkiIHN0cm9rZT0iIzMzODg3NyIgc3Ryb2tlLW9wYWNpdHk9IjAuMDciIHN0cm9rZS13aWR0aD0iNyIvPgo8cmVjdCB4PSI3MzkiIHk9IjMzIiB3aWR0aD0iNSIgaGVpZ2h0PSIzMSIgcng9IjIuNSIgdHJhbnNmb3JtPSJyb3RhdGUoLTE4MCA3MzkgMzMpIiBmaWxsPSIjRjlEQjZEIi8+CjxyZWN0IHg9IjcyMSIgeT0iMjAiIHdpZHRoPSI1IiBoZWlnaHQ9IjMxIiByeD0iMi41IiB0cmFuc2Zvcm09InJvdGF0ZSgtOTAgNzIxIDIwKSIgZmlsbD0iI0Y5REI2RCIvPgo8L3N2Zz4K";
export { SvgContentMarketingImageBg as ReactComponent };